import React from 'react';

const CardInfo = ({ children, className, title }) => (
  <div className={`${className || 'mx-4'}`}>
    <span className="text-sm text-gray-700">{title}</span>
    {children && <div className="text-base font-bold">{children}</div>}
  </div>
);

export default CardInfo;
